import React, { useEffect, useState } from "react";
import classes from "../Banner/Banner.module.css";
import axios from "../../../../axios";
import requests from "../../../../Request";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faPlay,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { videolinkupdate } from "../../../features/UserSlice";

const Banner = () => {
  const [movie, setMovie] = useState({});
  const [BannerArrays, setBannerArrays] = useState({});
  const [curridx, setCurrIdx] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      const ArrayBanner = [];
      for (let i = 0; i < 5; i++) {
        const request = await axios.get(requests.fetchNetflixOriginals);

        ArrayBanner.push(
          request.data.results[
            Math.floor(Math.random() * request.data.results.length - 1)
          ]
        );
      }
      setBannerArrays(ArrayBanner);
      setMovie(ArrayBanner[0]);
    }
    fetchData();
  }, []);

  function truncate(description, n) {
    return description?.length > n
      ? description.slice(0, n) + "..."
      : description;
  }

  function changeBanner(e) {
    if (e.currentTarget.value === "right") {
      const idx = (curridx + 1) % 5;

      setMovie(BannerArrays[idx]);
      setCurrIdx(idx);
    } else if (e.currentTarget.value === "left") {
      const idx = Math.abs((curridx - 1 + 5) % 5);

      setMovie(BannerArrays[idx]);
      setCurrIdx(idx);
    }
  }

  function handleWatch() {
    const seriesId = movie.id;
    const options = {
      method: "GET",
      credentials: "same-origin",
      headers: {
        accept: "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5ZWI5YWNlOGYyN2Q0ZWEzNjA4N2I2YTBhNDNhY2EyZCIsInN1YiI6IjY0YTY3YmZkMDdmYWEyMDBjN2VjMDMwNSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.9Z04wgkmVL20VmJnDpUesSbyuMUiMEYzZqHWKqx7xxs",
      },
    };


https: fetch(`https://api.themoviedb.org/3/tv/${seriesId}/videos`, options)
  .then((response) => response.json())
  .then((response) => {
    dispatch(
      videolinkupdate({
        key: response.results[0].key,
      })
    );
  })
  .catch((err) => console.error(err));
  }

  return (
    <header
      className={classes.banner}
      style={{
        backgroundSize: "cover",
        backgroundImage: `url(https://image.tmdb.org/t/p/original/${movie?.backdrop_path})`,
        backgroundPosition: "center center",
      }}
    >
      <div className={classes.banner_contents}>
        <button
          value="left"
          onClick={changeBanner}
          className={`${classes.left_swap} ${classes.swap_btn}`}
        >
          <FontAwesomeIcon
            icon={faChevronLeft}
            style={{
              width: "18px",
              height: "40px",
              color: "#111",
            }}
          />
        </button>
        <h1 className={classes.banner_title}>
          {movie?.name || movie?.title || movie?.original_name}
        </h1>
        <div className={classes.banner_description}>
          <h1>{truncate(movie?.overview, 150)}</h1>
        </div>
        <div className={classes.banner_buttons}>
          <button className={classes.banner_button} onClick={handleWatch}>
            <FontAwesomeIcon icon={faPlay} className={classes.icon} />
            Play
          </button>
          <button className={classes.banner_button}>
            <FontAwesomeIcon icon={faCircleInfo} className={classes.icon} />
            More info
          </button>
        </div>

        <button
          value="right"
          onClick={changeBanner}
          className={`${classes.right_swap} ${classes.swap_btn}`}
        >
          <FontAwesomeIcon
            icon={faChevronRight}
            style={{ width: "18px", height: "40px", color: "#111" }}
          />
        </button>
      </div>
      <div className={classes.banner_fadebottom} />
    </header>
  );
};

export default Banner;
